/**
 * Alta / edición de promoción (Marco) embebida.
 * /promociones/nueva → vacía
 * /promociones/:ref → recupera sesión
 */
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../components/ThemeProvider";

export default function PromocionAlta() {
  const { theme } = useTheme();
  const c = theme.colors;
  const navigate = useNavigate();
  const { ref: refParam } = useParams();
  const esNueva = !refParam;

  const uiSrc = useMemo(() => {
    if (esNueva) return "/api/movil/promocion/ui?embed=1&nueva=1";
    return `/api/movil/promocion/ui?embed=1&ref=${encodeURIComponent(refParam)}&auto=1`;
  }, [esNueva, refParam]);

  useEffect(() => {
    function onMessage(ev) {
      const data = ev && ev.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "marco-promo-volver-listado") {
        navigate("/promociones");
      }
    }
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [navigate]);

  return (
    <div
      className="flex flex-col"
      style={{
        height: "calc(100vh - 49px)",
        background: c.bgApp,
      }}
    >
      <iframe
        key={uiSrc}
        title={esNueva ? "Nueva promoción" : `Promoción ${refParam}`}
        src={uiSrc}
        className="w-full flex-1 min-h-0 border-0"
        style={{ background: c.bgCard || "#0f141c" }}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
